<template>
  <b-col cols="4" @click="show = true">
    <b-card class="pointer">
      <b-icon icon="circle-fill" :style="'color: ' + getColor + ';'"></b-icon>
      {{ softTenant._id }}
    </b-card>
    <b-modal :id="softTenant._id" v-model="show" :hide-footer="true" size="xl">
      <template #modal-header style="align-items: center">
        <h5 class="modal-title">{{ softTenant._id }}</h5>

        <span style="align-self: flex-end">
          <b-link
            target="_blank"
            :disabled="!remoteControlLink"
            :href="remoteControlLink"
          >
            <b-icon-box-arrow-up-right />
            Controle à distance
          </b-link>
          <b-icon-x
            class="h4 ml-2"
            style="cursor: pointer"
            @click="$bvModal.hide(softTenant._id)"
          ></b-icon-x>
        </span>
      </template>
      <TableView
        v-if="selectedTenant"
        :index="selectedTenant.index"
        :systemId="softTenant._source.reference"
        collection="alarm-history"
        @ackAlarm="onAckAlarm"
      />
    </b-modal>
  </b-col>
</template>

<script>
import 'ace-builds';
import 'ace-builds/webpack-resolver';
import TableView from './TableView.vue';
import { mapGetters } from 'vuex';
import { BIconX, BIconBoxArrowUpRight } from 'bootstrap-vue';
import get from 'lodash/get';

const CRITIC_ALARMS = ['8', '25', '43', '65', '73', '87'];
const WARNING_ALARMS = ['11', '22', '23', '49', '75', '77'];
export default {
  components: { TableView, BIconX, BIconBoxArrowUpRight },
  name: 'CardView',
  props: {
    softTenant: {
      type: Object,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
    collection: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      color: 'green',
      remoteControlLink: null,
    };
  },
  computed: {
    ...mapGetters('tenants', ['selectedTenant', 'selectedSoftTenant']),
    getColor() {
      return this.color;
    },
  },
  watch: {
    index: function () {
      this.fetchItems();
    },
    collection: function () {
      this.fetchItems();
    },
  },
  methods: {
    onAckAlarm(alarmId) {
      this.fetchItems();
    },
    async fetchItems() {
      let currentPage = 1;
      const items = [];
      let query = {
        query: {
          bool: {
            must: [
              {
                match: {
                  systemId: this.softTenant._source.reference,
                },
              },
            ],
          },
        },
      };
      this.$kuzzle.document
        .query({
          controller: 'pvstudio',
          action: 'technicalAlarms',
          index: this.index,
          collection: this.collection,
          query,
          from: (currentPage - 1) * 100,
          size: 100,
        })
        .then((res) => {
          res = res.result;
          items.splice(items, items.length);
          for (const doc of res.hits) {
            items.push({
              _id: doc._id,
              ...doc._source,
            });
          }
          this.color = 'green';
          items.forEach((item) => {
            CRITIC_ALARMS.forEach((id) => {
              if (item.alarmReasonId === id && item.datetimeAcq === undefined)
                this.color = 'red';
            });
            WARNING_ALARMS.forEach((id) => {
              if (item.alarmReasonId === id && item.datetimeAcq === undefined)
                this.color = 'orange';
            });
          });
        })
        .catch((error) => {
          this.$log.error(error);
          this.$bvToast.toast(
            'Désolé, une erreur est survenue lors de la récupération des alarmes techniques.',
            {
              title: 'Erreur',
              variant: 'danger',
              toaster: 'b-toaster-bottom-right',
              appendToast: true,
              dismissible: true,
              noAutoHide: true,
            }
          );
        });
      const residence = await this.$kuzzle.document.get(
        this.index,
        'assets',
        this.softTenant._id
      );
      if (!residence) {
        return this.$bvToast.toast(
          'Désolé, une erreur est survenue lors de la récupération du lien de contrôle à distance.',
          {
            title: 'Erreur',
            variant: 'warning',
            toaster: 'b-toaster-bottom-right',
            appendToast: true,
            dismissible: true,
            noAutoHide: true,
          }
        );
      }
      this.remoteControlLink = get(
        residence,
        '_source.metadata.remoteCtrlLink',
        null
      );
    },
  },
  mounted() {
    this.fetchItems();
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
</style>
